const o = 2, n = 0.2, c = {
  up: "10px",
  down: "-10px",
  unset: "unset"
}, r = {
  info: {
    color: "var(--b_5)",
    name: "icon-co_info_hollow"
  },
  success: {
    color: "var(--green_5)",
    name: "icon-co_success_hollow"
  },
  error: {
    color: "var(--red_5)",
    name: "icon-co_warning_hollow"
  },
  warning: {
    color: "var(--orange_5)",
    name: "icon-co_warning_hollow"
  }
};
export {
  c as ANIMATION_INIT_OFFSET,
  n as DEFAULT_ANIMATION_DURATION,
  o as DEFAULT_DURATION,
  r as messageIconInfo
};
//# sourceMappingURL=constants.mjs.map
